import React, { useState, useEffect } from "react";
import "./CookieBanner.scss";
import { translations } from "./texts";
import { BannerServiceOverview } from "./components/BannerServiceOverview";
import { BannerSignature } from "./components/BannerSignature";
const AVAILABLE_FONTS = [
    "Arial",
    "Verdana",
    "Tahoma",
    "Trebuchet MS",
    "Times New Roman",
    "Georgia",
    "Garamond",
    "Courier New",
    "Brush Script MT",
];
function getBorderRadius(borderStyle) {
    return borderStyle == "rounded"
        ? "4px"
        : borderStyle == "pill"
            ? "100px"
            : "0";
}
function applyButtonStyle(node, style) {
    const baseColor = style.buttonColor || style.primaryColor;
    const background = style.isEmphasized || style.disableFocusMainButton
        ? baseColor
        : lighterColor(baseColor);
    node.style.setProperty("background", background, "important");
    node.style.setProperty("color", style.buttonFontColor, "important");
    node.style.setProperty("border-radius", getBorderRadius(style.borderStyle), "important");
    // Apply button border if specified
    if (style.buttonBorderColor && style.buttonBorderWidth) {
        node.style.setProperty("border", `${style.buttonBorderWidth} solid ${style.buttonBorderColor}`, "important");
    }
    else {
        node.style.setProperty("border", "none", "important");
    }
}
function CookieBannerCustomizeScreen({ languageCode, primaryColor, buttonFontColor, borderStyle, cookiePolicy, cookieServices, acceptedServicesDefault, disableFocusMainButton, headingColor, buttonColor, toggleColor, buttonBorderColor, buttonBorderWidth, setHideBanner, onAcceptCustomizedCookies, }) {
    const [servicesAccepted, setServicesAccepted] = useState(cookieServices.map((cs) => acceptedServicesDefault.some((acs) => acs.id == cs.id)));
    const allAccepted = servicesAccepted.every((x) => x);
    const handleConfirm = () => {
        const selectedServices = [];
        for (let i = 0; i < cookieServices.length; i++) {
            if (servicesAccepted[i])
                selectedServices.push(cookieServices[i]);
        }
        onAcceptCustomizedCookies(selectedServices);
    };
    const t = translations(languageCode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "biskoui-cookie-banner-header", style: { color: headingColor || primaryColor } }, t.customize.header),
        React.createElement("div", { className: "biskoui-cookie-banner-body" },
            React.createElement("div", { className: "biskoui-cookie-banner-body-lead" }, t.customize.bodyLead),
            React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row" },
                React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row-label" }, t.customize.labelAcceptAll),
                React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row-toggle" },
                    React.createElement("label", { className: "biskoui-switch" },
                        React.createElement("input", { type: "checkbox", checked: allAccepted, onChange: (ev) => {
                                const checked = ev.target.checked;
                                setServicesAccepted((prev) => prev.map(() => checked));
                            } }),
                        React.createElement("span", { className: "biskoui-slider", style: {
                                backgroundColor: allAccepted ? (toggleColor || primaryColor) : "#CCCCCC",
                            } })))),
            React.createElement("div", null, cookieServices.map((cs, idx) => (React.createElement("div", { className: "biskoui-cookie-banner-cookie-service", key: cs.id.toString() },
                React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row" },
                    React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row-label" },
                        React.createElement("div", { className: "biskoui-cookie-banner-cookie-service-icon" },
                            React.createElement("img", { width: "28", height: "28", src: cs.iconPath })),
                        React.createElement("div", { className: "biskoui-cookie-banner-cookie-service-service" },
                            " ",
                            cs.service),
                        React.createElement("div", { className: "biskoui-cookie-banner-cookie-service-type" },
                            " ",
                            t.customize.cookieType[cs.cookieType])),
                    React.createElement("div", { className: "biskoui-cookie-banner-toggleable-row-toggle" },
                        React.createElement("label", { className: "biskoui-switch" },
                            React.createElement("input", { type: "checkbox", checked: servicesAccepted[idx], onChange: (ev) => {
                                    const checked = ev.target.checked;
                                    setServicesAccepted((prev) => {
                                        const n = [...prev];
                                        n[idx] = checked;
                                        return n;
                                    });
                                } }),
                            React.createElement("span", { className: "biskoui-slider", style: {
                                    backgroundColor: servicesAccepted[idx]
                                        ? (toggleColor || primaryColor)
                                        : "#CCCCCC",
                                } })))))))),
            React.createElement("div", { className: "biskoui-cookie-banner-footnote" },
                t.customize.privacyPolicyLead,
                " ",
                React.createElement("a", { target: "_blank", href: cookiePolicy, rel: "noreferrer" }, t.customize.privacyPolicyLinkedText))),
        React.createElement("div", { className: "biskoui-cookie-banner-buttons" },
            React.createElement("button", { className: "biskoui-cookie-banner-buttons-full", onClick: () => {
                    setHideBanner(true);
                    handleConfirm();
                }, ref: (node) => {
                    if (node) {
                        applyButtonStyle(node, {
                            isEmphasized: true,
                            primaryColor,
                            buttonFontColor,
                            borderStyle,
                            disableFocusMainButton,
                            buttonColor,
                            buttonBorderColor,
                            buttonBorderWidth,
                        });
                    }
                } }, t.customize.buttonConfirm))));
}
function CookieBannerHomeScreen({ languageCode, siteName, layout, primaryColor, buttonFontColor, borderStyle, cookieTypesUsed, cookiePolicy, showCookieWall, compact, disableFocusMainButton, headingColor, buttonColor, buttonBorderColor, buttonBorderWidth, setHideBanner, onAcceptAll, onRejectAll, onCustomize, }) {
    const isMobileBanner = window.matchMedia("(max-width: 600px)").matches;
    const t = translations(languageCode);
    const canCollapse = isMobileBanner && !showCookieWall && !compact && layout !== "minimize-rejectall";
    const [collapsed, setCollapsed] = useState(canCollapse);
    const emphasizeAcceptAll = layout == "emphasize-acceptall" || layout == "minimize-rejectall";
    const acceptAllButton = (React.createElement("button", { className: emphasizeAcceptAll
            ? "biskoui-cookie-banner-buttons-full"
            : "biskoui-cookie-banner-buttons-half", onClick: () => {
            setHideBanner(true);
            onAcceptAll();
        }, ref: (node) => {
            if (node) {
                applyButtonStyle(node, {
                    isEmphasized: emphasizeAcceptAll,
                    primaryColor,
                    buttonFontColor,
                    borderStyle,
                    disableFocusMainButton,
                    buttonColor,
                    buttonBorderColor,
                    buttonBorderWidth,
                });
            }
        } }, t.home.buttonAcceptAll));
    const rejectAllButton = (React.createElement("button", { className: "biskoui-cookie-banner-buttons-half", onClick: () => {
            setHideBanner(true);
            onRejectAll();
        }, ref: (node) => {
            if (node) {
                applyButtonStyle(node, {
                    isEmphasized: false,
                    primaryColor,
                    buttonFontColor,
                    borderStyle,
                    disableFocusMainButton,
                    buttonColor,
                    buttonBorderColor,
                    buttonBorderWidth,
                });
            }
        } }, t.home.buttonRejectAll));
    const emphasizeCustomize = layout == "emphasize-customize";
    const customizeButton = (React.createElement("button", { className: emphasizeCustomize ||
            (layout == "minimize-rejectall")
            ? "biskoui-cookie-banner-buttons-full"
            : "biskoui-cookie-banner-buttons-half", onClick: onCustomize, ref: (node) => {
            if (node) {
                applyButtonStyle(node, {
                    isEmphasized: emphasizeCustomize,
                    primaryColor,
                    buttonFontColor,
                    borderStyle,
                    disableFocusMainButton,
                    buttonColor,
                    buttonBorderColor,
                    buttonBorderWidth,
                });
            }
        } }, t.home.buttonCustomize));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "biskoui-cookie-banner-home" +
                (collapsed ? " biskoui-cookie-banner-collapsed" : "") },
            canCollapse && (React.createElement("div", { className: "biskoui-cookie-banner-collapse-toggle", onClick: () => setCollapsed(!collapsed) },
                collapsed && React.createElement("span", null,
                    t.home.collapseToggleExpand,
                    " \u25B2"),
                !collapsed && React.createElement("span", null,
                    t.home.collapseToggleCollapse,
                    " \u25BC"))),
            isMobileBanner && !canCollapse && layout !== "minimize-rejectall" && (
            // need to add a spacer because on mobile we disabled margin above the title.
            React.createElement("div", { style: { height: '10px' } })),
            (layout == "minimize-rejectall") && (React.createElement("div", { className: "biskoui-cookie-banner-link-rejectall", style: isMobileBanner
                    ? { textAlign: 'left', marginTop: '10px', marginBottom: '5px' }
                    : { textAlign: 'right' } },
                React.createElement("a", { onClick: () => {
                        setHideBanner(true);
                        onRejectAll();
                    } }, t.home.linkRejectAll))),
            React.createElement("div", { className: "biskoui-cookie-banner-header", style: { color: headingColor || primaryColor } },
                " ",
                t.home.header,
                " "),
            React.createElement("div", { className: "biskoui-cookie-banner-body" },
                collapsed && layout !== "minimize-rejectall" && t.home.bodyCollapsedLead,
                (!collapsed || layout === "minimize-rejectall") && (React.createElement(BannerServiceOverview, { t: t, cookieTypesUsed: cookieTypesUsed, compact: compact }))),
            React.createElement("div", { className: "biskoui-cookie-banner-footnote" },
                t.customize.privacyPolicyLead,
                " ",
                React.createElement("a", { target: "_blank", href: cookiePolicy, rel: "noreferrer" }, t.customize.privacyPolicyLinkedText)),
            React.createElement("div", { className: "biskoui-cookie-banner-buttons" },
                collapsed && (React.createElement(React.Fragment, null,
                    layout == "emphasize-customize" && (React.createElement(React.Fragment, null,
                        rejectAllButton,
                        acceptAllButton,
                        customizeButton)),
                    layout == "emphasize-acceptall" && (React.createElement(React.Fragment, null,
                        rejectAllButton,
                        customizeButton,
                        acceptAllButton)),
                    layout == "minimize-rejectall" && (React.createElement(React.Fragment, null,
                        customizeButton,
                        acceptAllButton)))),
                !collapsed && (React.createElement(React.Fragment, null,
                    isMobileBanner && (React.createElement(React.Fragment, null,
                        layout == "emphasize-customize" && (React.createElement(React.Fragment, null,
                            rejectAllButton,
                            acceptAllButton,
                            customizeButton)),
                        layout == "emphasize-acceptall" && (React.createElement(React.Fragment, null,
                            rejectAllButton,
                            customizeButton,
                            acceptAllButton)),
                        layout == "minimize-rejectall" && (React.createElement(React.Fragment, null,
                            customizeButton,
                            acceptAllButton)))),
                    !isMobileBanner && (React.createElement(React.Fragment, null,
                        layout == "emphasize-customize" && (React.createElement(React.Fragment, null,
                            acceptAllButton,
                            rejectAllButton,
                            customizeButton)),
                        layout == "emphasize-acceptall" && (React.createElement(React.Fragment, null,
                            customizeButton,
                            rejectAllButton,
                            acceptAllButton)),
                        layout == "minimize-rejectall" && (React.createElement(React.Fragment, null,
                            customizeButton,
                            acceptAllButton))))))))));
}
function CookieBannerBlockedScreen({ languageCode, primaryColor, buttonFontColor, borderStyle, disableFocusMainButton, buttonColor, buttonBorderColor, buttonBorderWidth, setHideBanner, onClose, }) {
    const t = translations(languageCode);
    return (React.createElement("div", null,
        React.createElement("div", { className: "biskoui-cookie-banner-blocked-logo" }, cookieBiteIcon),
        React.createElement("div", { className: "biskoui-cookie-banner-blocked-text" }, t.blocked.text),
        React.createElement("div", { className: "biskoui-cookie-banner-buttons" },
            React.createElement("button", { className: "biskoui-cookie-banner-buttons-full", onClick: () => {
                    if (onClose)
                        onClose();
                    setHideBanner(true);
                }, ref: (node) => {
                    if (node) {
                        applyButtonStyle(node, {
                            isEmphasized: true,
                            primaryColor,
                            buttonFontColor,
                            borderStyle,
                            disableFocusMainButton,
                            buttonColor,
                            buttonBorderColor,
                            buttonBorderWidth,
                        });
                    }
                } }, t.blocked.buttonClose))));
}
function BannerSticker({ backgroundColor, fontColor }) {
    const stickerDotStyle = {
        background: fontColor,
    };
    return (React.createElement("div", { style: {
            backgroundColor: backgroundColor,
            color: fontColor,
        }, className: "biskoui-cookie-banner-sticker" },
        React.createElement("div", { className: "biskoui-cookie-banner-sticker-dots" },
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle })),
        React.createElement("div", { className: "biskoui-cookie-banner-sticker-dots" },
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" })),
        React.createElement("div", { className: "biskoui-cookie-banner-sticker-dots" },
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot-hidden" }),
            React.createElement("div", { className: "biskoui-cookie-banner-sticker-dot", style: stickerDotStyle }))));
}
function CookieBanner({ siteName, layout, primaryColor, backgroundColor, fontColor, buttonFontColor, inheritFontFamily, fontFamily, borderStyle, bannerBorderColor, bannerBorderWidth, bannerPosition, stickerPosition, languageCode, cookiePolicy, cookieServices, cookieWallMode, cookieWallExceptions, compact, hideBannerDefault, acceptedServicesDefault, blocked, disableFocusMainButton, headingColor, buttonColor, toggleColor, buttonBorderColor, buttonBorderWidth, onAcceptAll, onRejectAll, onAcceptCustomizedCookies, onOpen, onClose, extraNode, discreteBranding, }) {
    const isMobileBanner = window.matchMedia("(max-width: 600px)").matches;
    // Whether we show the banner or we hide it and show the sticker to bring it back.
    const [hideBanner, setHideBanner] = useState(hideBannerDefault === undefined ? false : hideBannerDefault);
    const [showCookieWall, setShowCookieWall] = useState((cookieWallMode === "on" || (cookieWallMode === "mobile-only" && isMobileBanner)) &&
        !cookieWallExceptions.includes(window.location.pathname));
    const [showCustomizeScreen, setShowCustomizeScreen] = useState(false);
    const bannerStyle = {
        backgroundColor: backgroundColor,
        color: fontColor,
        fontFamily: inheritFontFamily
            ? "inherit"
            : AVAILABLE_FONTS.includes(fontFamily)
                ? fontFamily
                : AVAILABLE_FONTS[0],
        borderRadius: borderStyle == "rounded" ? "10px" : borderStyle == "pill" ? "20px" : "0",
        border: bannerBorderColor ? `${bannerBorderWidth || "1px"} solid ${bannerBorderColor}` : "none",
    };
    if (bannerPosition === "bottom-left")
        bannerStyle["left"] = "30px";
    else
        bannerStyle["right"] = "30px";
    const cookieTypesUsed = [];
    cookieServices.forEach((cs) => {
        if (!cookieTypesUsed.includes(cs.cookieType))
            cookieTypesUsed.push(cs.cookieType);
    });
    const stickerStyle = {
        position: "fixed",
        bottom: "30px",
    };
    if (stickerPosition === "visible" && bannerPosition == "bottom-left")
        stickerStyle["left"] = "30px";
    else if (stickerPosition == "visible" && bannerPosition == "bottom-right")
        stickerStyle["right"] = "30px";
    else if (stickerPosition == "none")
        stickerStyle["display"] = "none";
    useEffect(() => {
        if (hideBanner)
            setShowCookieWall(false);
    }, [hideBanner]);
    const t = translations(languageCode);
    if (hideBanner)
        return (React.createElement("div", { onClick: () => {
                if (onOpen)
                    onOpen();
                setHideBanner(false);
            }, style: stickerStyle },
            React.createElement(BannerSticker, { fontColor: fontColor, backgroundColor: backgroundColor })));
    return (React.createElement("div", { className: "biskoui-cookie-banner-wrapper" +
            (showCookieWall ? " biskoui-cookie-wall" : "") },
        React.createElement("div", { className: "biskoui-cookie-banner" +
                (isMobileBanner ? " biskoui-cookie-banner-mobile" : "") +
                (bannerPosition == "bottom-left"
                    ? " biskoui-cookie-banner-left"
                    : " biskoui-cookie-banner-right") +
                (borderStyle == "squared"
                    ? " biskoui-cookie-banner-border-square"
                    : borderStyle == "rounded"
                        ? " biskoui-cookie-banner-border-round"
                        : " biskoui-cookie-banner-border-pill"), style: bannerStyle },
            !blocked && !showCustomizeScreen && (React.createElement(CookieBannerHomeScreen, { languageCode: languageCode, siteName: siteName, layout: layout, primaryColor: primaryColor, buttonFontColor: buttonFontColor, borderStyle: borderStyle, cookieTypesUsed: cookieTypesUsed, cookiePolicy: cookiePolicy, showCookieWall: showCookieWall, compact: compact, disableFocusMainButton: disableFocusMainButton, headingColor: headingColor, buttonColor: buttonColor, buttonBorderColor: buttonBorderColor, buttonBorderWidth: buttonBorderWidth, setHideBanner: setHideBanner, onAcceptAll: () => {
                    if (onClose)
                        onClose();
                    onAcceptAll();
                }, onRejectAll: () => {
                    if (onClose)
                        onClose();
                    onRejectAll();
                }, onCustomize: () => setShowCustomizeScreen(true) })),
            !blocked && showCustomizeScreen && (React.createElement(CookieBannerCustomizeScreen, { languageCode: languageCode, primaryColor: primaryColor, buttonFontColor: buttonFontColor, borderStyle: borderStyle, cookiePolicy: cookiePolicy, cookieServices: cookieServices, acceptedServicesDefault: acceptedServicesDefault === undefined
                    ? []
                    : acceptedServicesDefault, disableFocusMainButton: disableFocusMainButton, headingColor: headingColor, buttonColor: buttonColor, toggleColor: toggleColor, buttonBorderColor: buttonBorderColor, buttonBorderWidth: buttonBorderWidth, setHideBanner: setHideBanner, onAcceptCustomizedCookies: (cookies) => {
                    if (onClose)
                        onClose();
                    onAcceptCustomizedCookies(cookies);
                    setShowCustomizeScreen(false);
                } })),
            blocked && (React.createElement(CookieBannerBlockedScreen, { languageCode: languageCode, primaryColor: primaryColor, buttonFontColor: buttonFontColor, borderStyle: borderStyle, disableFocusMainButton: disableFocusMainButton, buttonColor: buttonColor, buttonBorderColor: buttonBorderColor, buttonBorderWidth: buttonBorderWidth, setHideBanner: setHideBanner, onClose: onClose })),
            React.createElement(BannerSignature, { languageCode: languageCode, discrete: discreteBranding }),
            extraNode)));
}
function lighterColor(color) {
    // If it's already an rgba color, make it lighter while preserving low transparency
    if (color.startsWith('rgba(')) {
        const match = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (match) {
            const [, r, g, b, a] = match;
            const alpha = parseFloat(a);
            // If alpha is very low (0.2 or less), keep it as is to preserve the intended transparency
            if (alpha <= 0.2) {
                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }
            // For higher alpha values, reduce it multiplicatively but maintain minimum visibility
            const newAlpha = Math.max(0.3, alpha * 0.7);
            return `rgba(${r}, ${g}, ${b}, ${newAlpha})`;
        }
    }
    // If it's a hex color, add moderate transparency (maintaining original behavior)
    if (color.startsWith('#')) {
        return color + "AC"; // This adds ~67% transparency
    }
    // Fallback for other color formats
    return color + "AC";
}
const cookieBiteIcon = (React.createElement("svg", { width: "66", height: "66", viewBox: "0 0 66 66", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M23.7187 24.75C23.7187 23.042 22.333 21.6562 20.625 21.6562C18.917 21.6562 17.5312 23.042 17.5312 24.75C17.5312 26.458 18.917 27.8438 20.625 27.8438C22.333 27.8438 23.7187 26.4645 23.7187 24.75ZM37.125 29.9062C35.417 29.9062 34.0312 31.292 34.0312 33C34.0312 34.708 35.417 36.0938 37.125 36.0938C38.833 36.0938 40.2187 34.708 40.2187 33C40.2187 31.292 38.8394 29.9062 37.125 29.9062ZM24.75 42.2812C23.042 42.2812 21.6562 43.667 21.6562 45.375C21.6562 47.083 23.042 48.4688 24.75 48.4688C26.458 48.4688 27.8437 47.083 27.8437 45.375C27.8437 43.667 26.4644 42.2812 24.75 42.2812ZM45.375 42.2812C43.667 42.2812 42.2812 43.667 42.2812 45.375C42.2812 47.083 43.667 48.4688 45.375 48.4688C47.083 48.4688 48.4687 47.083 48.4687 45.375C48.4687 43.667 47.0894 42.2812 45.375 42.2812ZM63.757 32.9871C55.2969 32.8814 48.4687 26.0081 48.4687 17.5312C39.9944 17.5312 33.116 10.7031 33.0258 2.24297C32.2265 2.12309 31.4144 2.0625 30.6152 2.0625C28.1222 2.0625 25.6472 2.65199 23.3965 3.80016L15.0433 8.04504C12.0334 9.58547 9.58545 12.0334 8.04502 15.0434L3.81561 23.3578C2.27389 26.3871 1.72991 29.8031 2.25971 33.1547L3.72537 42.3689C4.25415 45.7076 5.82526 48.7884 8.2126 51.1758L14.8332 57.8003C17.2206 60.1721 20.2821 61.75 23.6221 62.2798L32.8827 63.7454C33.709 63.873 34.5469 63.9375 35.3848 63.9375C37.8778 63.9375 40.3747 63.348 42.6254 62.1998L50.9798 57.9395C53.9859 56.4132 56.4338 53.9666 57.9588 50.9605L62.2037 42.637C63.7183 39.6645 64.2598 36.2742 63.757 32.9871ZM58.5234 40.7602L54.2747 49.0914C53.1528 51.3021 51.3176 53.1364 49.1004 54.2631L40.746 58.5234C39.0972 59.3613 37.241 59.8125 35.3848 59.8125C34.7397 59.8125 34.12 59.7647 33.5221 59.6667L24.2627 58.201C21.7839 57.8085 19.5254 56.6593 17.7452 54.8907L11.1246 48.2559C9.34182 46.4732 8.19069 44.2134 7.79494 41.7178L6.33057 32.5087C5.93998 30.0094 6.33959 27.4957 7.49201 25.227L11.715 16.9164C12.87 14.6695 14.6695 12.8687 16.9125 11.7214L25.2721 7.47398C26.5476 6.82339 27.9417 6.40973 29.361 6.25543C31.0239 13.8274 37.1018 19.6746 44.7137 21.2859C46.2155 28.8914 52.1748 34.9757 59.7442 36.6515C59.5805 38.0789 59.1808 39.484 58.5234 40.7602Z", fill: "#484848" })));
export { AVAILABLE_FONTS, BannerSticker, CookieBanner };
//# sourceMappingURL=CookieBanner.js.map